
import { useEffect } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import HowItWorks from "@/components/HowItWorks";
import SecurityFooter from "@/components/SecurityFooter";
import CookieConsentBanner from "@/components/CookieConsentBanner";

const HowItWorksPage = () => {
  useEffect(() => {
    // Add canonical tag for SEO
    const canonicalLink = document.querySelector('link[rel="canonical"]');
    if (canonicalLink) {
      canonicalLink.setAttribute('href', 'https://zimkonnect.com/how-it-works');
    } else {
      const newCanonical = document.createElement('link');
      newCanonical.rel = 'canonical';
      newCanonical.href = 'https://zimkonnect.com/how-it-works';
      document.head.appendChild(newCanonical);
    }

    // Update page metadata
    document.title = "How ZimKonnect Works | Project Tracking for Zimbabwe Diaspora";
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Learn how ZimKonnect helps Zimbabwe diaspora track building projects, verify suppliers, and monitor progress in real-time. Simple 5-step process for peace of mind.');
    }
  }, []);

  return (
    <div className="min-h-screen bg-white overflow-x-hidden">
      <Header />
      <HowItWorks />
      <Footer />
      <SecurityFooter />
      <CookieConsentBanner />
    </div>
  );
};

export default HowItWorksPage;
